import { render, staticRenderFns } from "./smsDetail.vue?vue&type=template&id=52740910"
import script from "./smsDetail.vue?vue&type=script&lang=js"
export * from "./smsDetail.vue?vue&type=script&lang=js"
import style0 from "./smsDetail.vue?vue&type=style&index=0&id=52740910&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports